// @flow
import type {Node} from 'react'
import React from 'react'
import {useFragment, graphql} from 'react-relay'
import ProposalChangeSummary from 'components/proposals/Part/ui/ProposalChangeSummary'
import LoadingDots from 'components/ui/LoadingDots'

import type {
  SummarySections_change$key as SummarySectionsChangeType,
} from './__generated__/SummarySections_change.graphql'

const proposalFragment = graphql`
  fragment SummarySections_change on DescribeChangeable {
    summary {
      title
      sections 
    }
  }
`

type Props = {
  change: SummarySectionsChangeType,
}

function SummarySections(props: Props): Node {
  const data = useFragment(proposalFragment, props.change)

  return (
    data.summary
      ? <ProposalChangeSummary summary={data.summary} />
      : <LoadingDots sm />
  )
}

export default SummarySections
